<template>
    <section class="card mb-2">
        <FormSection title="Supply" :full-height="false">
            <template #content>
                <div class="row m-2">
                    <div class="col-12 col-md-4" v-for="(vendor, index) in patientVendors">
                        <PatientVendor
                            v-model:vendor-id="patientVendors[index]"
                            :provider-id="providerId"
                            v-model:patient-vendors="patientVendors"
                            :vendor-types="vendorTypes"
                            card-title="Supply Vendor"
                        ></PatientVendor>
                    </div>
                    <div class="col-12 mt-2">
                        <button
                            class="btn btn-outline-primary"
                            @click="addNewVendor()"
                            :disabled="!!patientVendors && patientVendors.length >= 5"
                        >
                            <i class="fas fa-plus"></i> Add Supply Vendor
                        </button>
                    </div>
                </div>
                <div class="row p-2">
                    <div class="col-12 d-flex">
                        <button
                            type="button"
                            class="btn btn-primary btn-xs ms-auto mb-2"
                            v-if="!isEditAllowed"
                            @click="updateSupplies()"
                        >
                            Update Supplies
                        </button>
                    </div>
                    <div class="col-12 col-md-6" v-if="isEditAllowed">
                        <div class="form-group row">
                            <label
                                for="medicare-number"
                                class="col-form-label col-12 col-md-5 text-md-end text-sm-start"
                                >Select Supply
                            </label>
                            <div class="col-12 col-md-7">
                                <TypeaheadInput
                                    :getData="getSupplyList"
                                    :value="selectionSupply"
                                    :disabled="showSupplyInputRow"
                                    :character-limit="3"
                                ></TypeaheadInput>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <table class="table table-responsive-md border border-gray">
                            <thead>
                                <tr class="bg-table-header">
                                    <th>Equipment Name</th>
                                    <th>Unit Cost</th>
                                    <th>Formulary</th>
                                    <th>Start Date</th>
                                    <th>End Date</th>
                                    <th class="text-end">Actions</th>
                                </tr>
                            </thead>
                            <!-- EMPTY -->
                            <tbody v-if="supplies.length == 0 && !showSupplyInputRow">
                                <TableEmpty :col-span="columns" component="supply" secondary-message="No Supply Added">
                                </TableEmpty>
                            </tbody>
                            <!-- NEW -->
                            <tbody v-if="showSupplyInputRow">
                                <SupplyTableRow
                                    :supply="savetoAdd"
                                    :is-new-supply="true"
                                    :update-supply="saveNewSupply"
                                    :cancel-new-supply="cancelNewSupply"
                                    :columns="columns"
                                >
                                </SupplyTableRow>
                            </tbody>
                            <!-- DATA -->
                            <tbody v-for="supply in supplies">
                                <SupplyTableRow
                                    :supply="supply"
                                    :update-supply="updateSupply"
                                    :delete-supply-from-list="deleteSupplyFromList"
                                    :columns="columns"
                                >
                                </SupplyTableRow>
                            </tbody>
                        </table>
                    </div>
                </div>
            </template>
        </FormSection>
    </section>
</template>

<script lang="ts" src="./PatientSupply.ts"></script>
